import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";

import { SearchForm } from "./org-search-form";
import { RegionSearchResults } from "./region-search-results";
import { CopyCoursePresenterProps } from "./types";

export const CopyCoursePresenter: React.FC<CopyCoursePresenterProps> = ({
  course,
  searchState,
  regionSearchStates,
  sourceOrgId,
  sourceRegionCode,
  onSearch,
  onCopyCourse,
  onBack,
  onSearchStateChange,
}) => {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <IconButton onClick={onBack} size="large" sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4">Copy &quot;{course.title}&quot;</Typography>
        </Box>
      </Box>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Select a destination organization to copy this course to
        </Typography>

        <SearchForm
          orgName={searchState.orgName}
          roleId={searchState.roleId}
          errorMessage={searchState.errorMessage}
          overwriteExisting={searchState.overwriteExisting}
          onSearch={onSearch}
          onChange={onSearchStateChange}
        />
      </Paper>

      {searchState.hasSearched && (
        <Grid container spacing={3}>
          {Object.entries(regionSearchStates).map(([region, state]) => (
            <Grid item xs={12} key={region}>
              <RegionSearchResults
                region={region}
                searchState={state}
                sourceOrgId={sourceOrgId}
                sourceRegionCode={sourceRegionCode}
                onCopy={(targetOrgId: string) =>
                  onCopyCourse(targetOrgId, region)
                }
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};
